import { PlusIcon } from '@heroicons/react/24/outline'
import type { BrandProduct } from '../../client'

const CHANGE = 'text-[10px] text-indigo-600 hover:underline'

function gridClass(count: number) {
  if (count === 1) return 'grid-cols-1 grid-rows-1'
  if (count === 2) return 'grid-cols-2 grid-rows-1'
  return 'grid-cols-2 grid-rows-2'
}

type Props = {
  companySelected: boolean
  products: BrandProduct[]
  brandName: string
  favicon: string | null
  host: string
  onOpenPicker: () => void
}

/** What sits in the "+ your product" tile once the picker is closed. */
export default function ProductSlot({ companySelected, products, brandName, favicon, host, onOpenPicker }: Props) {
  if (companySelected) {
    return (
      <div className="flex size-full flex-col items-center justify-center p-4 text-center">
        <span className="mb-2 flex size-16 items-center justify-center rounded-full bg-purple-50">
          {favicon ? (
            <img src={favicon} alt="" referrerPolicy="no-referrer" className="size-10 rounded object-contain" />
          ) : (
            <span className="text-xl font-semibold text-purple-900">{(brandName[0] ?? '?').toUpperCase()}</span>
          )}
        </span>
        <p className="max-w-full truncate text-xs font-semibold text-slate-800">{brandName || 'Company'}</p>
        {host && <p className="max-w-full truncate text-[10px] text-slate-500">{host}</p>}
        <button type="button" onClick={onOpenPicker} className={`mt-2 ${CHANGE}`}>
          Change
        </button>
      </div>
    )
  }

  if (products.length > 0) {
    return (
      <div className="flex size-full flex-col gap-2 p-3">
        <div className={`grid min-h-0 flex-1 gap-1.5 ${gridClass(products.length)}`}>
          {products.map((product) => (
            <span key={product.id} className="relative overflow-hidden rounded border border-slate-200 bg-white">
              {product.image_urls?.[0] && (
                <img src={product.image_urls[0]} alt={product.label} className="size-full object-cover" />
              )}
            </span>
          ))}
        </div>
        <button type="button" onClick={onOpenPicker} className={CHANGE}>
          Change
        </button>
      </div>
    )
  }

  return (
    <button
      type="button"
      onClick={onOpenPicker}
      className="flex size-full flex-col items-center justify-center gap-1 text-xs text-slate-500 transition hover:text-slate-700"
    >
      <PlusIcon className="size-5" />
      Add your product
    </button>
  )
}
